/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createTunnelStressArea } from '../fn/tunnel-stress-area-controller/create-tunnel-stress-area';
import { CreateTunnelStressArea$Params } from '../fn/tunnel-stress-area-controller/create-tunnel-stress-area';
import { deleteTunnelStressArea } from '../fn/tunnel-stress-area-controller/delete-tunnel-stress-area';
import { DeleteTunnelStressArea$Params } from '../fn/tunnel-stress-area-controller/delete-tunnel-stress-area';
import { getTunnelStressArea } from '../fn/tunnel-stress-area-controller/get-tunnel-stress-area';
import { GetTunnelStressArea$Params } from '../fn/tunnel-stress-area-controller/get-tunnel-stress-area';
import { getTunnelStressAreas } from '../fn/tunnel-stress-area-controller/get-tunnel-stress-areas';
import { GetTunnelStressAreas$Params } from '../fn/tunnel-stress-area-controller/get-tunnel-stress-areas';
import { getTunnelStressAreasFiltered } from '../fn/tunnel-stress-area-controller/get-tunnel-stress-areas-filtered';
import { GetTunnelStressAreasFiltered$Params } from '../fn/tunnel-stress-area-controller/get-tunnel-stress-areas-filtered';
import { PageTunnelStressAreaDto } from '../models/page-tunnel-stress-area-dto';
import { TunnelStressAreaDto } from '../models/tunnel-stress-area-dto';
import { updateTunnelStressArea } from '../fn/tunnel-stress-area-controller/update-tunnel-stress-area';
import { UpdateTunnelStressArea$Params } from '../fn/tunnel-stress-area-controller/update-tunnel-stress-area';

@Injectable({ providedIn: 'root' })
export class TunnelStressAreaControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTunnelStressArea()` */
  static readonly GetTunnelStressAreaPath = '/v1/tunnelstressarea/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTunnelStressArea()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTunnelStressArea$Response(params: GetTunnelStressArea$Params, context?: HttpContext): Observable<StrictHttpResponse<TunnelStressAreaDto>> {
    return getTunnelStressArea(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTunnelStressArea$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTunnelStressArea(params: GetTunnelStressArea$Params, context?: HttpContext): Observable<TunnelStressAreaDto> {
    return this.getTunnelStressArea$Response(params, context).pipe(
      map((r: StrictHttpResponse<TunnelStressAreaDto>): TunnelStressAreaDto => r.body)
    );
  }

  /** Path part for operation `updateTunnelStressArea()` */
  static readonly UpdateTunnelStressAreaPath = '/v1/tunnelstressarea/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTunnelStressArea()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTunnelStressArea$Response(params: UpdateTunnelStressArea$Params, context?: HttpContext): Observable<StrictHttpResponse<TunnelStressAreaDto>> {
    return updateTunnelStressArea(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTunnelStressArea$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTunnelStressArea(params: UpdateTunnelStressArea$Params, context?: HttpContext): Observable<TunnelStressAreaDto> {
    return this.updateTunnelStressArea$Response(params, context).pipe(
      map((r: StrictHttpResponse<TunnelStressAreaDto>): TunnelStressAreaDto => r.body)
    );
  }

  /** Path part for operation `deleteTunnelStressArea()` */
  static readonly DeleteTunnelStressAreaPath = '/v1/tunnelstressarea/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTunnelStressArea()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTunnelStressArea$Response(params: DeleteTunnelStressArea$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTunnelStressArea(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTunnelStressArea$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTunnelStressArea(params: DeleteTunnelStressArea$Params, context?: HttpContext): Observable<void> {
    return this.deleteTunnelStressArea$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTunnelStressAreas()` */
  static readonly GetTunnelStressAreasPath = '/v1/tunnelstressarea';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTunnelStressAreas()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTunnelStressAreas$Response(params?: GetTunnelStressAreas$Params, context?: HttpContext): Observable<StrictHttpResponse<PageTunnelStressAreaDto>> {
    return getTunnelStressAreas(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTunnelStressAreas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTunnelStressAreas(params?: GetTunnelStressAreas$Params, context?: HttpContext): Observable<PageTunnelStressAreaDto> {
    return this.getTunnelStressAreas$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageTunnelStressAreaDto>): PageTunnelStressAreaDto => r.body)
    );
  }

  /** Path part for operation `createTunnelStressArea()` */
  static readonly CreateTunnelStressAreaPath = '/v1/tunnelstressarea';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTunnelStressArea()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTunnelStressArea$Response(params: CreateTunnelStressArea$Params, context?: HttpContext): Observable<StrictHttpResponse<TunnelStressAreaDto>> {
    return createTunnelStressArea(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTunnelStressArea$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTunnelStressArea(params: CreateTunnelStressArea$Params, context?: HttpContext): Observable<TunnelStressAreaDto> {
    return this.createTunnelStressArea$Response(params, context).pipe(
      map((r: StrictHttpResponse<TunnelStressAreaDto>): TunnelStressAreaDto => r.body)
    );
  }

  /** Path part for operation `getTunnelStressAreasFiltered()` */
  static readonly GetTunnelStressAreasFilteredPath = '/v1/tunnelstressarea/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTunnelStressAreasFiltered()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTunnelStressAreasFiltered$Response(params: GetTunnelStressAreasFiltered$Params, context?: HttpContext): Observable<StrictHttpResponse<PageTunnelStressAreaDto>> {
    return getTunnelStressAreasFiltered(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTunnelStressAreasFiltered$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTunnelStressAreasFiltered(params: GetTunnelStressAreasFiltered$Params, context?: HttpContext): Observable<PageTunnelStressAreaDto> {
    return this.getTunnelStressAreasFiltered$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageTunnelStressAreaDto>): PageTunnelStressAreaDto => r.body)
    );
  }

}
